export interface DictionaryFuelPriceIndexAddRequest {
    name: string;
    symbol: string;
    uom1: string;
    uom2: string;
}
